export default __webpack_public_path__ + "assets/86c80f5644df15b863955624c2a80ef1.fnt";